import { render } from "./Spinner.vue?vue&type=template&id=b15f8ed0"
import script from "./Spinner.vue?vue&type=script&lang=js"
export * from "./Spinner.vue?vue&type=script&lang=js"
script.render = render

export default script